<template>
  <b-modal id="kkm-card-pay-modal"
           size="lg"
           hide-footer
           no-close-on-backdrop
           hide-header-close
           centered>
    <div class="alert alert-warning text-center">
      <div class="text-center mb-3 pt-3">
        <b-spinner></b-spinner>
      </div>
      {{ $t('waiting_for_payment_in_terminal') }}
    </div>
  </b-modal>
</template>

<script setup>
defineProps({
  modalResolve: {
    type: Function,
    default: () => {}
  },
  status: {
    type: [Number, null],
    default: null
  }
})
</script>
